﻿export const constantApp = {
  NAMECOMPANY: "گردش کار آپافن",
  NAMEAPP: "گردش کار آپافن",
  // SERVERIP: "http://localhost",
  //  SERVERIP: "http://171.22.25.159",
  // SERVERIP: "http://192.168.180.254",
  PORT_APPACHE: "80",
  // SERVERIP: "http://apafan.com",
  // SERVERIP: "http://apafan.ir",
  SERVERIP: "http://api.apafan.ir",
  version: "1.0.0",
};
